/**
 * 站点数据源 · 中文
 * ---------------------------------------------------------------
 * 与 site.en.js 保持完全相同的导出结构，仅内容为中文。
 * 两者由 src/data/site.js 按当前语言切换导出，组件无需感知语言。
 */

/* ---------------- 联系方式 ---------------- */
export const CONTACT = {
  phone: '+86 18820037803',
  phoneHref: 'tel:+8618820037803',
  email: 'vancheen@prolinker.top',
  addr: '中国 广东省 广州市',
  faceBook: 'ProLinker / VANCHEEN Mall',
  site: 'https://www.vancheen.com/'
}

export const COMPANY = {
  name: 'VANCHEEN',
  subtitle: '汽车配件 · 建筑材料'
}

/* ---------------- 主导航 ---------------- */
export const NAV_ITEMS = [
  { key: 'home', label: '首页', to: '/' },
  { key: 'about', label: '关于我们', to: '/about' },
  { key: 'b2b', label: 'B2B大宗贸易', to: '/topProduct?BPCId=1&Active=1' },
  { key: 'b2c', label: 'B2C零售商城', to: '/home' },
  { key: 'factory', label: '工厂参观', to: '/factory' },
]

/* ---------------- 两条业务线系列 ---------------- */
export const AUTO_SERIES = [
  { en: 'Chassis Parts', zh: '底盘件' },
  { en: 'Engine Parts', zh: '发动机件' },
  { en: 'Brake System', zh: '刹车系统' },
  { en: 'Suspension Parts', zh: '悬挂件' },
  { en: 'Steering System', zh: '转向系统' },
  { en: 'Body Parts', zh: '车身件' },
  { en: 'Electrical Parts', zh: '电气件' },
  { en: 'Cooling System', zh: '冷却系统' }
]

export const BUILD_SERIES = [
  { en: 'Tiles', zh: '瓷砖' },
  { en: 'Sanitary Ware', zh: '卫浴洁具' },
  { en: 'Aluminum Doors & Windows', zh: '铝门窗' },
  { en: 'Stone', zh: '石材' },
  { en: 'Pipes & Fittings', zh: '管材管件' },
  { en: 'Waterproofing', zh: '防水材料' },
  { en: 'Insulation', zh: '保温材料' }
]

/* ---------------- 页脚 ---------------- */
export const FOOTER = {
  intro:
    'VANCHEEN 是一家立足中国的工业品出口供应商，为全球客户提供高品质的汽车配件与建筑材料——具备 OEM/ODM 能力、工厂直供价格与可靠的全球发运。',
  quickLinks: [
    { label: '关于我们', to: '/about' },
    { label: '产品中心', to: '/products' },
    { label: '工厂参观', to: '/factory' },
  ],
  productLines: [
    { label: '汽车配件', to: '/products?cat=auto' },
    { label: '建筑材料', to: '/products?cat=building' },
    { label: '底盘与发动机', to: '/products' },
    { label: '瓷砖与卫浴', to: '/products' },
    { label: '铝门窗', to: '/products' }
  ],
  social: [
    { label: '领英 LinkedIn', img: 'qrcode1.png' },
    { label: 'Facebook', img: 'qrcode2.png' }
  ],
  copyright: '迎客商服控股（广州）有限公司版权所有',
  legal: [
    { label: '粤ICP备20012225号-1', href: 'https://beian.miit.gov.cn/' },
    { label: '联系支持', href: 'mailto:vancheen@prolinker.top' }
  ]
}

/* ---------------- 首页：Hero 轮播 ---------------- */
export const HERO_SLIDES = [
  {
    img: 'hero-banner-1.jpg',
    alt: '出口汽车配件与建筑材料',
    eyebrow: 'GUANGZHOU VANCHEEN · 工业品出口供应商',
    titleHtml:
      '在 <span class="accent">汽车配件</span> 与 <span class="accent">建筑材料</span> 领域<br>做你可靠的出口伙伴',
    subHtml:
      '<b>OEM/ODM · 全球发运 · 全程品控</b> —— 从合作工厂到你的港口，覆盖底盘件、发动机件、刹车件、瓷砖、卫浴等品类。',
    ctas: [{ label: '浏览产品', to: '/products', cls: 'btn-primary' }],
    tags: ['具备 ISO 9001 能力', '支持 OEM / ODM', '出口 30+ 国家', '整柜海运']
  },
  {
    img: 'hero-banner-3.jpg',
    alt: '全球集装箱海运与物流',
    eyebrow: '成熟的物流体系',
    titleHtml: '从广州到你的港口 ——<br><span class="accent">准时 · 稳定 · 可预期</span>',
    subHtml:
      '<b>海运、空运与门到门方案</b>，拼柜定班、全程可追踪，在中东、非洲等市场实现 98% 准时交付。',
    ctas: [{ label: '查看产品目录', to: '/products', cls: 'btn-ghost-light' }],
    tags: ['整柜 / 拼箱', '门到门', '全程可追踪', '支持 DDU']
  }
]

export const HERO_SLIDE_ARCHIVE = [
  {
    img: 'hero-banner-2.jpg',
    alt: '自动化工厂生产线',
    eyebrow: '工厂直供制造',
    titleHtml: '自有自动化工厂制造，<br><span class="accent">按你的规格交付</span>',
    subHtml:
      '精密加工、机器人装配与 <b>全流程可追溯品控</b>，以有竞争力的工厂价格，交付符合严格质量标准的汽车配件。',
    ctas: [
      { label: '参观工厂', to: '/factory', cls: 'btn-primary' },
      { label: '了解品控流程', to: '/quality', cls: 'btn-ghost-light' }
    ],
    tags: ['CNC 加工', '机器人装配', '自有品控实验室', '定制工装']
  }
]

/* ---------------- 首页：数字统计 ---------------- */
export const STATS = [
  { value: 15, suffix: '+', label: '年出口经验' },
  { value: 30, suffix: '+', label: '个国家和地区' },
  { value: 2000, suffix: '+', label: '款在供 SKU' },
  { value: 98, suffix: '%', label: '准时交付率' }
]

/* ---------------- 首页：两大业务支柱 ---------------- */
export const PILLARS = [
  {
    key: 'auto',
    to: '/topProduct?BPCId=1&Active=1',
    tag: '汽车配件',
    title: '汽车配件 · Auto Parts',
    img: 'hero-banner-2.jpg',
    alt: '汽车配件制造',
    desc: '精密制造的汽车配件——底盘、发动机、刹车、悬挂、转向、冷却等系统，覆盖乘用车与商用车，来自值得信赖的 OEM / 售后市场制造商。',
    series: ['底盘件', '发动机件', '刹车系统', '悬挂件', '转向系统', '冷却系统'],
    linkText: '查看汽车配件'
  },
  {
    key: 'building',
    to: '/topProduct?BPCId=1&Active=1',
    tag: '建筑材料',
    title: '建筑材料 · Building Materials',
    img: 'marble.jpg',
    alt: '建筑材料',
    desc: '瓷砖、卫浴洁具、铝门窗、石材、管材与防水材料——面向中东、非洲与亚洲的住宅及商业项目，来自值得信赖的制造商，经久耐用。',
    series: ['瓷砖', '卫浴洁具', '铝门窗', '石材', '管材', '防水材料'],
    linkText: '查看建筑材料'
  }
]

/* ---------------- 首页：精选产品（4 + 4） ---------------- */
export const FEATURED_AUTO = [
  {
    cat: 'auto',
    tag: '底盘',
    img: 'control-arm.jpg',
    alt: '悬挂控制臂',
    name: '控制臂与悬挂衬套',
    en: 'Control Arms & Suspension Bushings',
    desc: '上/下控制臂、球头与衬套，锻钢或冲压钢成型，表面带防锈涂层。',
    meta: []
  },
  {
    cat: 'auto',
    tag: '发动机',
    img: 'engine-piston.jpg',
    alt: '发动机活塞与连杆',
    name: '活塞、连杆与发动机部件',
    en: 'Pistons, Connecting Rods & Engine Parts',
    desc: '汽油与柴油发动机内部全套件——活塞、活塞环、连杆、垫片与正时套件。',
    meta: []
  },
  {
    cat: 'auto',
    tag: '刹车',
    img: 'brake.jpg',
    alt: '刹车盘与卡钳',
    name: '刹车盘、刹车片与卡钳',
    en: 'Brake Discs, Pads & Calipers',
    desc: '高碳刹车盘配防锈涂层，陶瓷 / 半金属刹车片与再制造卡钳。',
    meta: []
  },
  {
    cat: 'auto',
    tag: '转向',
    img: 'tie-rod.jpg',
    alt: '转向拉杆球头',
    name: '转向拉杆球头与转向传动件',
    en: 'Tie Rod Ends & Steering Linkage',
    desc: '内 / 外拉杆球头、直拉杆与齿条接头，精密螺纹，长寿命防尘套。',
    meta: []
  }
]

export const FEATURED_BUILDING = [
  {
    cat: 'building',
    tag: '瓷砖',
    img: 'ceramic-tiles.jpg',
    alt: '陶瓷釉面砖',
    name: '陶瓷砖与抛光砖',
    en: 'Ceramic & Porcelain Tiles',
    desc: '釉面砖、抛光砖与通体砖，规格 600×600、800×800、600×1200，按 PEI 耐磨等级分级。'
  },
  {
    cat: 'building',
    tag: '卫浴',
    img: 'faucet.jpg',
    alt: '浴室龙头与台盆',
    name: '卫浴洁具与浴室配件',
    en: 'Sanitary Ware & Bathroom Fittings',
    desc: '台盆、坐便器、镀铬龙头与淋浴产品——节水设计，无铅黄铜主体。'
  },
  {
    cat: 'building',
    tag: '铝型材',
    img: 'aluminum-window.jpg',
    alt: '铝合金门窗型材',
    name: '铝合金门窗',
    en: 'Aluminum Doors & Windows',
    desc: '断桥铝推拉与平开系统，RAL 色系粉末喷涂，专为沙漠气候适配。'
  },
  {
    cat: 'building',
    tag: '石材',
    img: 'marble.jpg',
    alt: '大理石板材',
    name: '大理石板材与天然石材',
    en: 'Marble & Natural Stone Slabs',
    desc: '白色、米色与灰色大理石板材及规格砖，定厚处理并做树脂加固，便于施工铺贴。'
  }
]

/* ---------------- 首页：Why VANCHEEN（10 个教训） ---------------- */
export const LESSONS = [
  {
    title: '图纸画得清清楚楚，工厂却理解成了另一个样子。',
    what: '你发去详细的图纸，工厂回复"没问题"。大货到货——尺寸不对、装不上。工厂一摊手："我们理解的是另一种做法。"',
    help: '我们把你的图纸翻译成车间能执行的作业指令。批量投产前先做首件确认——双方在同一页上，再开线。'
  },
  {
    title: '样品说 OK，大货说不行，怎么办？',
    what: '样品你确认了。大货到货——304 钢变成了 201，镀层更薄、密度更低。工厂说"样品是手工做的，有差异很正常"。你手里有照片，却没有实物样品。没有证据，就没有谈判筹码。',
    help: '我们保留一份双方签字确认的封样实物。大货生产前先对照封样做首件检验。一旦有争议，这就是硬证据。'
  },
  {
    title: '质量标准从没落到纸面上，最后只能各说各话。',
    what: '你说"焊缝不平整"。工厂说"这已经是标准品质了"。你这才意识到——可接受的色差范围？划痕允许多少？从来没写下来过。双方各有各的标准，没法收场。',
    help: '我们和工厂签一份书面的《质量验收标准》——公差、缺陷等级，一条一条写清楚，作为合同附件。达不到标准，我们就不收货。'
  },
  {
    title: '工厂在 PPT 上很大，却喂不动你这张订单。',
    what: '工厂的 PPT 写着"产值 5 亿、员工 500 人"。你下单、付定金。交期到了——"设备故障""环保检查""原材料短缺"。三个月过去，货还散落在车间地上。真相是：只有两条产线。旺季一来，你的订单被排到了最后。',
    help: '每一家工厂我们都实地去看——数清实际产线、核对近三个月排产计划、查看准时交付记录。产能占用超过 80% 的工厂，我们不推荐。你的订单，要交给真正有余量的产线。'
  },
  {
    title: '同一个活，三份报价；最便宜的那份，往往不是最划算的。',
    what: '三份报价：5 万、4.2 万、7.5 万美元。你选了最便宜的。货到了——3mm 的钢板变成 2.5mm，标准螺栓换成非标件，两道油漆变成一道。同一张图纸，不同的成色。你比的是数字，没比数字背后被砍掉的东西。',
    help: '我们把每一份报价拆开看——材料等级、镀层厚度、工艺、利润。遇到低得可疑的报价，我们会追问材料来源和工艺方案。我们比的是同一标准下的价格，而不是谁的数字更小。'
  },
  {
    title: '货的成本你算得很清楚，运费却把利润吃掉了。',
    what: '你以为拿到了不错的采购价。等运费单一来——海运费、燃油附加费、超重附加费——几乎占掉货值的一半。瓷砖多几吨就吃超重罚款，沙发少几件单件运费就飙升。这些成本，货好了才看得见。那时已经没有退路。',
    help: '重货——精确配载，不罚款、不浪费吨位。泡货——优化装柜顺序，把柜内空间用满。我们替你比对船公司与船期。规划做在前面，成本才管得住。'
  },
  {
    // 原文此处第一个色块误用了 .help 类，这里保持原样（whatClass 用于还原）
    whatClass: 'help',
    title: '装柜时没人在场，出了问题就没人认。',
    what: '目的地开柜——瓷砖缺角、沙发刮花、包装压塌。工厂说"出厂时是好的"，货代说"内部损坏不是我们的责任"。没人担责，损失你自己扛。',
    help: '我们现场监督装柜——装柜前确认包装完好，重下轻上，不压不挤。全程照片与视频留档，封柜号登记在案。一旦到货有损，影像记录能把责任说清楚。'
  },
  {
    title: '三个品类、三家工厂，你一个人在三头跑。',
    what: '建材找 A，家具找 B，汽配找 C。A 说"要晚一周"，B 说"要改包装"，C 说"款到才发货"。三个交期、三套包装标准、三条物流链路——全压在你身上。你一天到晚不是在回消息，就是在等消息。',
    help: '我们做你唯一的对接窗口。所有时间节点汇总到一张跟踪表，所有包装标准统一协调，所有物流进度统一跟进。每周一份汇总进度报告。一个窗口，管三家工厂。'
  },
  {
    title: '工厂等你一句话，你在太平洋那头睡得正香。',
    what: '产线故障、环保检查、原料短缺——一出事工厂第一时间找你。可你那边是凌晨三点。等你醒来回复，产线已经停了半天。小问题拖成三天，交期整整推迟一周。',
    help: '我们的本地团队当天就跟进——评估影响，先和工厂拿出临时解决方案。在你做最终决定之前，事情先稳住。把小问题在早期控住，别让它变成大延误。'
  },
  {
    title: '单证上一个数字打错，柜子就在码头趴了几周。',
    what: 'HS 编码错了一位——海关扣下你的柜子。你要改单、重新申报、跑码头——可你不在中国。货在码头趴着，客户天天打电话。',
    help: '从下单开始我们就协助处理出口单证——核对品名、材质、用途、申报价值与实际货物是否一致。出货前再自查一遍。单证齐全准确，清关才少折腾。'
  }
]

/* ---------------- 首页：工厂速览 ---------------- */
export const FACTORY_TEASER = {
  img: 'factory-cnc.jpg',
  alt: 'VANCHEEN 自动化工厂与 CNC 加工',
  mediaTag: '自有自动化生产基地',
  mediaIcon: 'factory',
  kicker: '工厂参观',
  title: '看看我们如何制造并管控每一个零件',
  desc: '我们位于广州的生产基地集成了 CNC 加工、机器人装配与自有检测能力。跟我们一起走一遍车间——线上或到厂——看你订单的每一道工序在哪里完成。',
  checks: [
    { text: '12,000 m² 生产与仓储面积', cls: 'done' },
    { text: '40+ 台 CNC 及自动化设备', cls: 'done' },
    { text: '严格的品质控制流程', cls: 'done' },
    { text: '厂内自有品控实验室', cls: 'done' },
    { text: '可按需提供实时视频参观', cls: 'auto' },
    { text: '样品 7–15 天可出', cls: 'auto' }
  ],
  cta: { label: '完整参观工厂', to: '/factory', cls: 'btn-primary' }
}

/* ---------------- 产品目录页 ---------------- */
export const PRODUCT_FILTERS = [
  { value: 'all', label: '全部产品' },
  { value: 'auto', label: '汽车配件' },
  { value: 'building', label: '建筑材料' }
]

export const PRODUCT_CATALOG = [
  {
    cat: 'auto',
    tag: '底盘',
    img: 'control-arm.jpg',
    alt: '悬挂控制臂',
    name: '控制臂与球头',
    en: 'Control Arms & Ball Joints',
    desc: '上 / 下控制臂、球头与衬套——锻钢或冲压钢成型，表面带防锈涂层。',
    meta: []
  },
  {
    cat: 'auto',
    tag: '发动机',
    img: 'engine-piston.jpg',
    alt: '发动机活塞组',
    name: '活塞与发动机内部件',
    en: 'Pistons & Engine Internals',
    desc: '汽油与柴油发动机的活塞、活塞环、连杆、垫片与正时套件。',
    meta: []
  },
  {
    cat: 'auto',
    tag: '刹车',
    img: 'brake.jpg',
    alt: '刹车盘与卡钳',
    name: '刹车盘、刹车片与卡钳',
    en: 'Brake Discs, Pads & Calipers',
    desc: '高碳刹车盘、陶瓷 / 半金属刹车片与再制造卡钳，带防锈涂层。',
    meta: []
  },
  {
    cat: 'auto',
    tag: '转向',
    img: 'tie-rod.jpg',
    alt: '转向拉杆球头',
    name: '转向拉杆球头与转向传动件',
    en: 'Tie Rod Ends & Steering Linkage',
    desc: '内 / 外拉杆球头、直拉杆与齿条接头，精密螺纹，长寿命防尘套。',
    meta: []
  },
  {
    cat: 'building',
    tag: '瓷砖',
    img: 'ceramic-tiles.jpg',
    alt: '陶瓷砖',
    name: '陶瓷砖与抛光砖',
    en: 'Ceramic & Porcelain Tiles',
    desc: '釉面砖、抛光砖与通体砖，规格 600×600 / 800×800 / 600×1200，按 PEI 耐磨等级分级。',
    meta: []
  },
  {
    cat: 'building',
    tag: '卫浴',
    img: 'faucet.jpg',
    alt: '浴室龙头',
    name: '卫浴洁具与配件',
    en: 'Sanitary Ware & Fittings',
    desc: '台盆、坐便器、镀铬龙头与淋浴产品——无铅黄铜主体，节水设计。',
    meta: []
  },
  {
    cat: 'building',
    tag: '铝型材',
    img: 'aluminum-window.jpg',
    alt: '铝合金门窗',
    name: '铝合金门窗',
    en: 'Aluminum Doors & Windows',
    desc: '断桥铝推拉与平开系统，RAL 色系粉末喷涂，专为沙漠气候适配。',
    meta: []
  },
  {
    cat: 'building',
    tag: '石材',
    img: 'marble.jpg',
    alt: '大理石板材',
    name: '大理石与天然石材',
    en: 'Marble & Natural Stone',
    desc: '白色、米色与灰色大理石板材及规格砖，定厚处理并做树脂加固，便于施工铺贴。',
    meta: []
  },
  {
    cat: 'building',
    tag: '管材',
    img: 'pipes.jpg',
    alt: '管材与管件',
    name: '管材与管件',
    en: 'Pipes & Fittings',
    desc: 'PPR、PVC 及金属管材，配套齐全的管件系列，适用于给排水工程。',
    meta: []
  },
  {
    cat: 'building',
    tag: '防水',
    img: 'waterproofing.jpg',
    alt: '防水卷材',
    name: '防水材料',
    en: 'Waterproofing Materials',
    desc: 'APP / SBS 改性沥青卷材、液体涂料与胶带，适用于屋面与基础防水。',
    meta: []
  }
]

/* ---------------- 关于我们页 ---------------- */
export const ABOUT_INTRO = {
  img: 'hero-banner-2.jpg',
  alt: 'VANCHEEN 公司概览',
  mediaTag: '广州出口团队',
  mediaIcon: 'users',
  kicker: '公司简介',
  title: '把复杂的采购，变成一次可靠的握手',
  paragraphs: [
    {
      text: 'VANCHEEN 创立时的想法很简单：全球买家不该为了汽车配件和建筑材料，在几十家工厂与贸易公司之间来回周旋。我们围绕两个我们深入了解的行业建立了专注的供应链，并依托在中国的合作伙伴生产基地和工厂提供支持。'
    },
    {
      text: '今天，我们的团队服务中东、非洲、东南亚等市场的分销商、批发商与项目采购方——提供 OEM/ODM 支持、工厂直供价格与端到端的物流服务。',
      style: 'margin-top:14px;'
    }
  ],
  checks: [
    { text: '15+ 年出口经验', cls: 'done' },
    { text: '服务 30+ 个国家和地区', cls: 'done' }
  ]
}

export const ABOUT_VALUES = [
  {
    icon: 'globe',
    title: '我们的使命',
    desc: '让汽车配件与建筑材料的全球采购变简单——交付可靠的品质、诚实的价格，以及关键时刻找得到人的合作伙伴。'
  },
  {
    icon: 'factory',
    title: '我们的愿景',
    desc: '成为新兴市场分销商与项目客户的首选中国采购伙伴——以稳定、透明和速度赢得口碑。'
  },
  {
    icon: 'shield',
    title: '我们的价值观',
    desc: '每一份报价都守诚信。每一个批次都讲精度。从询价到售后都负责任。看重长期关系，而非一锤子买卖。'
  }
]

export const ABOUT_MILESTONES = [
  {
    icon: 'clock',
    title: '2015 · 公司成立',
    desc: '在广州组建了出口团队，为首批中东经销商提供服务'
  },
  {
    icon: 'tag',
    title: '2020 · 新增建筑材料',
    desc: '扩展至瓷砖、卫浴产品和铝合金门窗，服务于建筑项目买家'
  },
  {
    icon: 'users',
    title: '2025 · 制造合作伙伴关系进一步拓展',
    desc: '与广东的加工和装配工厂合作'
  }
]

/* ---------------- 工厂页（Factory Tour：合作工厂实拍） ---------------- */
/**
 * 合作工厂实拍照片墙
 * 照片来自你订单背后的合作工厂生产线，不是样板间、不是摆拍。
 * img 留空时渲染占位底纹；填入实拍图文件名即可自动切换（图片放 src/assets/images/）。
 */
export const FACTORY_PHOTOS = [
  {
    tag: '木门',
    title: '木门',
    img: 'woodenDoor.jpg',
    alt: '合作工厂的木门生产线'
  },
  {
    tag: '卫浴洁具',
    title: '卫浴洁具',
    img: 'sanitaryWare.jpg',
    alt: '合作工厂的卫浴洁具生产线'
  },
  {
    tag: '胶水机',
    title: '胶水机',
    img: 'glueMachinery.jpg',
    alt: '合作工厂的胶水机生产车间'
  },
  {
    tag: '汽车配件',
    title: '汽车配件',
    img: 'autoParts.jpg',
    alt: '合作工厂的汽车配件生产线'
  }
]

/* ---------------- 品控页 ---------------- */
export const QC_INTRO = {
  img: 'qc-lab.jpg',
  alt: 'VANCHEEN 品质控制实验室',
  mediaTag: '厂内品控实验室',
  mediaIcon: 'shield',
  kicker: '我们的做法',
  title: '检验融入每一道工序，而不是最后一道关卡',
  paragraphs: [
    `我们不把品质寄托在最后一道终检上，而是持续控制。每一批次在我们的体系中都留有可追溯的检验记录——欢迎你随时审核、委托第三方验货，或通过实时视频监督任一环节。`
  ],
  checks: [
    { text: 'ISO 9001 质量管理体系', cls: 'done' },
    { text: '全批次可追溯', cls: 'done' },
    { text: '检验报告同步给买家', cls: 'done' },
    { text: '欢迎第三方验货', cls: 'done' }
  ]
}

export const QC_STEPS = [
  { num: '01', title: '供应商审核', desc: '材料与零部件供应商每年审核并重新认证。' },
  { num: '02', title: '来料检验', desc: '原材料与铸件在投产前对照规格书验证。' },
  { num: '03', title: '首件检验', desc: '每一批次首件做完整尺寸符合性检验。' },
  { num: '04', title: '过程控制', desc: '在每个加工 / 装配工序做尺寸与外观检查。' },
  { num: '05', title: '实验室检测', desc: '厂内完成硬度、镀层厚度、气孔与材质分析。' },
  { num: '06', title: '功能测试', desc: '运动部件做扭矩、行程与装配适配性测试。' },
  { num: '07', title: '包装检查', desc: '出口包装做防潮、抗冲击与适航性验证。' },
  { num: '08', title: '出货前 AQL 抽检', desc: '出货前按 ISO 2859-1（AQL 1.5 / 2.5）随机抽样。' }
]

export const QC_BADGES = [
  'ISO 9001:2015',
  'ECE R90（刹车）',
  'ISO 13006（瓷砖）',
  'ISO 2859-1 AQL',
  'CE（卫浴）'
]

/* ---------------- 新闻页 ---------------- */
export const NEWS = [
  {
    img: 'hero-banner-3.jpg',
    alt: '迪拜 Automechanika 展会',
    date: '2026 年 7 月 · 展会',
    title: 'VANCHEEN 将参展 2026 迪拜 Automechanika',
    desc: '在本地区规模最大的汽车售后市场展会上与我们的出口团队见面。面向 GCC 市场的全新底盘与刹车项目将现场展出。'
  },
  {
    img: 'hero-banner-2.jpg',
    alt: '新增机器人装配线',
    date: '2026 年 6 月 · 工厂',
    title: '广州工厂新增机器人装配线正式投产',
    desc: '刹车与底盘件产能提升 40%，大批量出口订单的交期进一步缩短。'
  },
  {
    img: 'warehouse.jpg',
    alt: '拼柜定班发运',
    date: '2026 年 5 月 · 物流',
    title: '拼柜定班计划现已覆盖杰贝阿里及更多港口',
    desc: '汽车配件与建筑材料可混装同一柜，固定船期、运费透明。'
  },
  {
    img: 'ceramic-tiles.jpg',
    alt: '沙特 The Big 5 建材展',
    date: '2026 年 4 月 · 展会',
    title: '建筑材料产品线亮相沙特 The Big 5',
    desc: '面向沙特建筑热潮的瓷砖、卫浴与铝门窗——主打通过沙漠气候测试的表面处理。'
  },
  {
    img: 'qc-lab.jpg',
    alt: '品控实验室检测升级',
    date: '2026 年 3 月 · 品质',
    title: '品控实验室扩充镀层与材料检测能力',
    desc: '新增镀层测厚与材料分析设备，缩短 OEM 项目的认证周期。',
    more: { label: '了解品控流程', to: '/quality' }
  },
  {
    img: 'marble.jpg',
    alt: '石材新系列发布',
    date: '2026 年 1 月 · 产品',
    title: '石材系列新增大理石与石英石产品',
    desc: '六款新石材饰面现已提供大板与定尺加工规格，适用于室内精装项目。',
    more: { label: '查看该系列', to: '/products?cat=building' }
  }
]

/* ---------------- 各页 CTA 条 ---------------- */
export const CTA = {
  about: {
    title: '建立长期合作关系',
    desc: '告诉我们你的市场和目标产品——我们会准备一份量身定制的采购方案。',
    actions: [{ label: '浏览产品', href: 'https://www.vancheen.com/topProduct?BPCId=1&Active=1', external: true, }]
  },
  products: {
    title: '需要 OEM / ODM 定制？',
    desc: '把你的图纸、样品或目标规格发给我们——工程师将在 24 小时内回复可行性评估与报价。',
    actions: [{ label: '返回首页', to: '/' }]
  },
  factory: {
    title: '想看某家具体的工厂？',
    desc: '告诉我们你想看的产品或工厂——我们会在合作工厂为你安排视频连线或实地考察。',
    actions: [
      {
        label: '预约工厂参观',
        href: 'https://www.vancheen.com/topProduct?BPCId=1&Active=1',
      }
    ]
  },
  quality: {
    title: '想亲自验证品质？',
    desc: '我们支持你的团队或第三方机构做出货前检验，也可按需同步实时生产进度。',
    actions: [{ label: '参观工厂', to: '/factory' }]
  },
  news: {
    title: '获取最新目录与价格表',
    desc: '订阅或联系我们，直接获取新产品系列、市场报告与船期安排。',
    actions: [{ label: '浏览产品', href: 'https://www.vancheen.com/topProduct?BPCId=1&Active=1', external: true, }]
  },
  home: {
    title: '准备采购汽车配件与建筑材料？',
    desc: '把你要找的配件或材料与数量发给我们——获取含直供价格、交期与运费估算的详细报价。',
    actions: [
      { label: '浏览产品', href: 'https://www.vancheen.com/topProduct?BPCId=1&Active=1', external: true, cls: 'btn-ghost-light' }
    ]
  }
}
